export const isCoachRecipient = (note, user) => Boolean(note && user?.id && user?.companyId &&
  Number(note.companyId) === Number(user.companyId) &&
  Number(note.targetUserId) === Number(user.id) &&
  Number(note.authorUserId) !== Number(user.id));

export const coachNavigationKey = user => `soluwhats:pendingCoachMessage:${user?.companyId}:${user?.id}`;
